"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarredMessage = void 0;
const models_1 = require("@home-health-notify/models");
const mappers_1 = require("../mappers");
const Observable_1 = require("../socket/Observable");
const DomainEvents_1 = require("../utils/DomainEvents");
const StarredMessageUtils_1 = require("./StarredMessageUtils");
const MessageUtils_1 = require("../mappers/MessageUtils");
class StarredMessage {
    constructor(organizationUser, httpAdapter, userDirectory, hhnStorage, socketAdapter) {
        this.organizationUser = organizationUser;
        this.httpAdapter = httpAdapter;
        this.userDirectory = userDirectory;
        this.hhnStorage = hhnStorage;
        this.socketAdapter = socketAdapter;
        this.starredMessages = { data: [], limit: 0, total: 0, hasNext: false };
    }
    fetchStarredMessages() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const requestPayload = {
                    total: ((_a = this.starredMessages) === null || _a === void 0 ? void 0 : _a.total) || 0,
                };
                const { organizationId } = this.organizationUser.getOrganization();
                const response = yield this.httpAdapter
                    .getStarredMessageAdapter()
                    .fetchStarredMessages(requestPayload, organizationId);
                this.starredMessages = (0, mappers_1.starredMessageMapper)(response, this.starredMessages, this.userDirectory, this.organizationUser, this.httpAdapter, this.socketAdapter);
                this.updateStarMessageCount();
                return this.starredMessages;
            }
            catch (e) {
                console.error("Error fetching starred messages", e);
                throw e;
            }
        });
    }
    getStarredMessages() {
        return this.starredMessages;
    }
    updateStarMessageCount() {
        // Update starred message count in the organization storage
        this.hhnStorage.orgStorage.setStarredMessageCount(this.starredMessages.total || 0);
    }
    addToStarredMessageList(cb, message) {
        const chatInfo = this.hhnStorage.chatStorage.getChatInfoByChatType(message.getMessage().chatType, message.getMessage().chatId);
        this.starredMessages = (0, StarredMessageUtils_1.addToList)(this.starredMessages, message, chatInfo);
        this.updateStarMessageCount();
        cb(this.starredMessages);
    }
    removeFromStarMessageList(cb, message) {
        this.starredMessages = (0, StarredMessageUtils_1.removeFromList)(this.starredMessages, message);
        this.updateStarMessageCount();
        cb(this.starredMessages);
    }
    updateStarredMessageList(cb, message) {
        const updatedMessage = (0, MessageUtils_1.makeMessage)(message, this.userDirectory, this.organizationUser, this.httpAdapter, this.socketAdapter);
        this.starredMessages = (0, StarredMessageUtils_1.updateMessageInList)(this.starredMessages, updatedMessage);
        cb(this.starredMessages);
    }
    starMessageListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.STAR_MESSAGE, this.organizationUser.getOrganization().organizationId), (data) => {
            this.addToStarredMessageList(cb, data);
        });
    }
    unstarMessageListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UNSTAR_MESSAGE, this.organizationUser.getOrganization().organizationId), (data) => {
            this.removeFromStarMessageList(cb, data);
        });
    }
    addAcknowledgementListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.ALERT_UPDATE, this.organizationUser.getOrganization().organizationId), (message) => this.updateStarredMessageList(cb, message));
    }
    unstarAllMessages() {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                action: models_1.STAR_MESSAGE_ACTIONS.UNMARK,
            };
            yield this.httpAdapter.getMessageAdapter().setMessageStar(payload);
            this.starredMessages = { data: [], limit: 0, total: 0, hasNext: false };
            this.updateStarMessageCount();
            Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UNSTAR_ALL_MESSAGES, this.organizationUser.getOrganization().organizationId), this);
        });
    }
    unstarAllMessagesListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UNSTAR_ALL_MESSAGES, this.organizationUser.getOrganization().organizationId), cb);
    }
}
exports.StarredMessage = StarredMessage;
